import { extractErrorMessage, get, post } from "src/helpers/api_helper"
import { IConfig, ResponsePagination, ResponseRequest, INotification, IUserNotification, INotificationResponse } from "./types"

export const fetchNotificationsSent = async (config: IConfig): Promise<ResponseRequest<ResponsePagination<INotification>>> => {
    try {
        let params: any = { ...config }
        if (config?.event_type == 'all') {
            delete params.event_type
        }
        const response = await get<ResponsePagination<INotification>>('/admin-notifications', { params })
        if (response.code === 200) {
            return { result: "ok", data: response.data! }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}

export const sendNotification = async ( data : { userIds: string[], title: string, body: string, isSelectAllUsers: boolean } ): Promise<ResponseRequest<INotificationResponse>> => {
    try {
        const response = await post<INotificationResponse>('/admin-notifications/send', { ...data, selected: data.isSelectAllUsers ? 'ALL' : null })
        if (response.code === 200) {
            return { result: "ok", data: response.data! }
        } else {
            return { result: "error", message: response.message }
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}
export const fetchUserWhomNotificationWasSent = async (config: IConfig, notificationId: string, filterUsersToValidate: boolean|null|'all'): Promise<ResponseRequest<ResponsePagination<IUserNotification>>> => {
    try {
        let params: any = { ...config }
        const response = await get<ResponsePagination<IUserNotification>>(`/admin-notifications/${notificationId}/users`, { params })
        if (response.code === 200) {
            return { result: "ok", data: response.data! }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}
